export const cloneDeep = <T>(x: T): T => JSON.parse(JSON.stringify(x));